module.exports = __webpack_public_path__ + "img/KSC09960.ba9103d4.jpg";